( (window, document) => {
  "use strict";
  const $ = window.jQuery;

  let immo_slider = document.querySelectorAll('.vodl-immo-slider.pre-init');

  // Re-fetch all available non-intitialized immo-slider(s).
  const init_immo_slider_newpage = () => {

    immo_slider = document.querySelectorAll('.vodl-immo-slider.pre-init');

    if ( immo_slider.length > 0 ) {
      immo_slider.forEach( slider => {
        init_immo_slider( slider );
      });

      window.removeEventListener( 'newPage', init_immo_slider_newpage, false );
    }

  };

  const init_immo_slider = ( slider ) => {

    const slider_wrapper = slider.querySelector('.vodl-immo-slider__carousel-wrapper-slider');

    const sliderAttr = {
      speed: 250,
      slideWidth: 220,
      minSlides: 2,
      maxSlides: 4,
      slideMargin: 15,
      infiniteLoop: false,
      hideControlOnEnd: true,
    };

    $(slider_wrapper).bxSlider(sliderAttr);

    const height = slider.querySelector('.bx-wrapper').clientHeight + 'px';
    slider.querySelector('.bx-viewport').style.height = height;

    // Prevent Firefox from opening tabs twice.
    slider.addEventListener("click", (e) => {
      if (e.isTrusted && e.pointerId === undefined) {
        e.preventDefault();
      }
    });

    slider.addEventListener('touchmove', (e) => {
      e.preventDefault();
    });

    // Initialized - remove lazy stuff (there's supposed to be only one slider per page).
    slider.classList.remove('pre-init');

  };

  $(document).ready( () => {

    if ( immo_slider.length > 0 ) {

      immo_slider.forEach( slider => {
        init_immo_slider( slider );
      });

    } else {

      // Initialize event listener for lazy immo slider.
      window.addEventListener('newPage', init_immo_slider_newpage, false);
    }

  });

})(window, document);
